import cn from 'classnames';
import { Controller, useFormContext } from 'react-hook-form';
import { MenuDropdown } from '@widgets/programs/common/dropdown-menu';
import { ArrowDown } from '@shared/assets';
import { MenuItem, useCommonMenu } from '@shared/ui';
import { Loader } from '@src/library/components/common/index.ts';
import * as st from './styles.module.scss';
import { useProgramsAccessDurationsQuery } from '@src/api/api-hooks/programs/useProgramsAccessDurationsQuery.ts';

export const Period = (): JSX.Element => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const { data } = useProgramsAccessDurationsQuery();

  const periods = data?.map((el) => ({ value: el.id, label: el.title })) || [];

  const { onClose, onOpen, popperEl, referenceEl, setPopperEl, setReferenceEl } = useCommonMenu();

  return (
    <Controller
      control={control}
      name="access_duration"
      render={({ field: { value, onChange, onBlur } }) => (
        <div className={st.period}>
          <div
            className={cn(st.period__field, !!errors.period && st.period__error)}
            onClick={onOpen}
            ref={setReferenceEl}
          >
            <span>{value ? periods.find((period) => period.value === value)?.label : ''}</span>
            <div className={st.icon}>
              <ArrowDown />
            </div>
          </div>
          <MenuDropdown
            popperEl={popperEl}
            referenceEl={referenceEl}
            setPopperEl={setPopperEl}
            offset={[0, 0]}
            dropdownClasses={st.period__dropdown}
          >
            {periods?.length ? (
              periods.map((period) => (
                <MenuItem
                  key={period.value}
                  onClick={(e) => {
                    onClose(e);
                    onChange(period.value);
                  }}
                  onBlur={onBlur}
                  className={st.period__item}
                >
                  {period.label}
                </MenuItem>
              ))
            ) : (
              <Loader />
            )}
          </MenuDropdown>
        </div>
      )}
    />
  );
};
